import React, { useEffect, useState, useMemo } from "react";
import {
  Badge,
  Button,
  Col,
  ProgressBar,
  Spinner,
  Table,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { BsPencilSquare, BsTrash } from "react-icons/bs";
import { FaTasks } from "react-icons/fa";
import { FcAcceptDatabase } from "react-icons/fc";
import { IoDocumentTextOutline } from "react-icons/io5";
import { MdHistory } from "react-icons/md";
import { format } from "date-fns";
import ReactPaginate from "react-paginate";

import {
  deleteWorkPackageById,
  fetchWorkPackages,
} from "../../../../store/features/workPackage/workPackageSlice";

import WorkPackageHistoryModal from "./WorkPackageHistoryModal";
import AcceptedWpFormModal from "./AcceptedWpFormModal";
import { fetchUserById } from "../../../../store/features/user/userSlice";
import { toast } from "react-toastify";
import NoDataFound from "../../../../components/NoDataFound";
import { TbPackages } from "react-icons/tb";
import FilterData from "../../../projectManagement/projects/components/FilterData";
import { STATUS_OPTIONS } from "../../../../utils/filterOptions";
import { filterBySearchAndStatus } from "../../../../utils/filterUtils";
const WorkPackageTableData = ({
  setTabKey,
  setWorkPackaesInfo,
  setWpInfo,
  projectInfo,
  setProjectInfo,
  setShowWpModal,
}) => {
  const dispatch = useDispatch();

  const { workPackages, loading, pagination } = useSelector(
    (state) => state.workPackages
  );
  const { tasks } = useSelector((state) => state.tasks);
  const { managers } = useSelector((state) => state.users);
  const { role, _id } = useSelector((state) => state.auth);

  const [showAccepted, setShowAccepted] = useState(false);
  const [showWorkPackageHistory, setShowWorkPackageHistory] = useState(false);
  const [selectedWorkPackage, setSelectedWorkPackage] = useState({});
  const [wpInfoData, setWpInfoData] = useState({});
  const [currentPage, setCurrentPage] = useState(0);
  const [expandedDescriptions, setExpandedDescriptions] = useState({});
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("");

  const limit = 10;

  useEffect(() => {
    dispatch(fetchWorkPackages({ page: currentPage + 1, limit }));
  }, [dispatch, currentPage]);
  const roleFilteredWorkPackages = useMemo(() => {
    if (role === "manager") {
      return workPackages.filter((wp) => !wp.rejectionReason);
    }

    if (projectInfo?._id) {
      return workPackages.filter((wp) => wp.project?._id === projectInfo._id);
    }

    return workPackages;
  }, [workPackages, projectInfo, role]);

  const filteredWorkPackages = useMemo(() => {
    return filterBySearchAndStatus({
      data: roleFilteredWorkPackages,
      searchTerm,
      statusFilter,
      searchKeys: ["title", "description", "wpNumber"],
    });
  }, [roleFilteredWorkPackages, searchTerm, statusFilter]);

  // const filteredWorkPackages = useMemo(() => {
  //   if (role === "manager") {
  //     return workPackages.filter((wp) => !wp.rejectionReason);
  //   } else if (projectInfo?._id) {
  //     return workPackages.filter((wp) => wp.project?._id === projectInfo._id);
  //   }
  //   return workPackages;
  // }, [workPackages, projectInfo, role]);

  const toggleDescription = (id) =>
    setExpandedDescriptions((prev) => ({ ...prev, [id]: !prev[id] }));

  const getManagerName = (managerId) =>
    managers?.find((m) => m._id === managerId)?.name || "-";

  const getProgressStatus = (progress = 0) => {
    if (progress === 0) return "Pending";
    if (progress < 50) return "At Risk";
    if (progress < 100) return "On Track";
    return "Completed";
  };

  const handleEdit = (wp) => {
    setWorkPackaesInfo({});
    setWorkPackaesInfo(wp);
    setShowWpModal(true);
  };

  const handleDelete = async (id) => {
    try {
      await dispatch(deleteWorkPackageById(id)).unwrap();
      await dispatch(fetchWorkPackages({ page: currentPage + 1, limit }));
      await dispatch(fetchUserById(_id));
      toast.info("WorkPackage deleted");
    } catch {
      toast.error("Error deleting WorkPackage");
    }
  };

  const handleHistory = (wp) => {
    setSelectedWorkPackage({ wpId: wp._id, title: wp.title });
    setShowWorkPackageHistory(true);
  };

  const handleWpAcceptedModal = (wp) => {
    setWpInfoData(wp);
    setShowAccepted(true);
  };

  return (
    <div>
      {loading ? (
        <Spinner animation="border" />
      ) : (
        <>
          {workPackages.length > 0 ? (
            <div className="table-wrapper mt-3">
              {/* <FilterData
                searchValue={searchTerm}
                onSearchChange={handleSearchChange}
                searchPlaceholder="Search projects..."
                selectConfigs={[
                  {
                    label: "All Status",
                    value: statusFilter,
                    onChange: setStatusFilter,
                    options: STATUS_OPTIONS,
                  },
                ]}
              /> */}
              <FilterData
                searchValue={searchTerm}
                onSearchChange={setSearchTerm}
                searchPlaceholder="Search work packages..."
                selectConfigs={[
                  {
                    label: "All Status",
                    value: statusFilter,
                    onChange: setStatusFilter,
                    options: STATUS_OPTIONS,
                  },
                ]}
              />

              <Col className="text-end me-2">
                <Button
                  size="sm"
                  style={{ fontSize: 10 }}
                  onClick={() => {
                    setProjectInfo({});
                    setWorkPackaesInfo({});
                  }}
                >
                  Show All WP
                </Button>
              </Col>

              {/* <div className="table-wrapper mt-3"> */}
              <Table responsive>
                <thead>
                  <tr>
                    <th>Title</th>
                    <th>Description</th>
                    <th>Project Name</th>
                    <th>Assigned Manager</th>
                    <th>WP Number</th>
                    <th>Cost</th>
                    <th>Effort (mo)</th>
                    <th>Accepted</th>
                    {role !== "manager" && <th>Decline Reason</th>}
                    <th>Progress</th>
                    <th>Status</th>
                    <th>Start</th>
                    <th>End</th>
                    <th>Attachments</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredWorkPackages.map((wp) => {
                    const managerId = wp.managerIds?.[0];

                    return (
                      <tr key={wp._id}>
                        <td style={{ minWidth: 150 }}>
                          <span
                            className="text-primary cursor-pointer"
                            onClick={() => {
                              setWpInfo(wp);
                              setTabKey(
                                wp.deliverableCount ? "deliverables" : "tasks"
                              );
                            }}
                          >
                            {wp.title}
                          </span>
                          {wp.approvalStatus === "pending" && (
                            <Badge
                              bg="danger"
                              className="ms-1"
                              style={{ fontSize: 9 }}
                            >
                              New
                            </Badge>
                          )}
                          <p
                            style={{
                              fontSize: 12,
                              color: "#666",
                              fontWeight: 600,
                            }}
                          >
                            <small>{wp.deliverableCount} Deliverables</small>{" "}
                            &nbsp;
                            <small>{wp.taskCount} Tasks</small>
                          </p>
                        </td>

                        <td style={{ minWidth: 200 }}>
                          {wp.description?.length > 50 ? (
                            <>
                              {expandedDescriptions[wp._id]
                                ? wp.description
                                : `${wp.description.slice(0, 50)}... `}
                              <span
                                onClick={() => toggleDescription(wp._id)}
                                style={{ color: "blue", cursor: "pointer" }}
                              >
                                {expandedDescriptions[wp._id]
                                  ? "Show less"
                                  : "Show more"}
                              </span>
                            </>
                          ) : (
                            wp.description
                          )}
                        </td>

                        <td>{wp.project?.projectName}</td>
                        <td>{getManagerName(managerId)}</td>
                        <td>{wp.wpNumber}</td>
                        <td>{wp.cost}</td>
                        <td>{wp.personMonths}</td>

                        <td>
                          {wp.approvalStatus && (
                            <Badge
                              bg={
                                wp.approvalStatus === "Accepted"
                                  ? "success"
                                  : "danger"
                              }
                            >
                              {wp.approvalStatus}
                            </Badge>
                          )}
                        </td>

                        {role !== "manager" && (
                          <td>{wp.rejectionReason || "-"}</td>
                        )}

                        <td className="text-center">
                          <div className="progessbar-wrapper">
                            <div className="progressbar-tooltip">
                              {`${wp.progressLevel || 0}%`}
                            </div>
                            <ProgressBar now={wp.progressLevel || 0} />
                          </div>
                        </td>

                        <td>
                          <Badge
                            className="mt-1"
                            bg={
                              wp.progressLevel < 50
                                ? "danger"
                                : wp.progressLevel < 100
                                ? "info"
                                : "success"
                            }
                          >
                            {getProgressStatus(wp.progressLevel)}
                          </Badge>
                        </td>

                        <td>{format(new Date(wp.startDate), "MM/dd/yyyy")}</td>
                        <td>{format(new Date(wp.endDate), "MM/dd/yyyy")}</td>

                        <td>
                          {Array.isArray(wp.wpAttachments) &&
                            wp.wpAttachments.length > 0 && (
                              <div className="d-flex flex-wrap">
                                {wp.wpAttachments.map((doc, i) => (
                                  <Button
                                    key={i}
                                    variant="light"
                                    className="me-1"
                                  >
                                    <a
                                      href={doc}
                                      target="_blank"
                                      rel="noreferrer"
                                      download
                                    >
                                      <IoDocumentTextOutline size="1.2rem" />
                                    </a>
                                  </Button>
                                ))}
                              </div>
                            )}
                        </td>

                        <td className="actions">
                          <Button
                            size="sm"
                            title="History"
                            onClick={() => handleHistory(wp)}
                          >
                            <MdHistory size="1.2rem" />
                          </Button>

                          {role !== "auditor" && (
                            <Button
                              size="sm"
                              title="Tasks"
                              onClick={() => {
                                setWpInfo(wp);
                                setTabKey("tasks");
                              }}
                            >
                              <FaTasks />
                            </Button>
                          )}

                          {role !== "manager" && role !== "auditor" && (
                            <>
                              <Button
                                size="sm"
                                title="Edit"
                                onClick={() => handleEdit(wp)}
                              >
                                <BsPencilSquare />
                              </Button>
                              <Button
                                size="sm"
                                variant="danger"
                                title="Delete"
                                onClick={() => handleDelete(wp._id)}
                              >
                                <BsTrash />
                              </Button>
                            </>
                          )}

                          {role === "manager" && (
                            <Button
                              size="sm"
                              title="Accepted"
                              onClick={() => handleWpAcceptedModal(wp)}
                            >
                              <FcAcceptDatabase />
                            </Button>
                          )}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
              {/* </div> */}
            </div>
          ) : (
            <NoDataFound
              icon={<TbPackages size={50} />}
              title="Work Packages not found"
              description="Try to add some work packages."
            />
          )}
        </>
      )}

      {showAccepted && (
        <AcceptedWpFormModal
          showAccepted={showAccepted}
          setShowAccepted={setShowAccepted}
          wpInfoData={wpInfoData}
        />
      )}

      {showWorkPackageHistory && (
        <WorkPackageHistoryModal
          showWorkPackageHistory={showWorkPackageHistory}
          setShowWorkPackageHistory={setShowWorkPackageHistory}
          selectedWorkPackage={selectedWorkPackage}
        />
      )}

      {pagination?.totalPages > 1 && (
        <div className="d-flex justify-content-center mt-3">
          <ReactPaginate
            breakLabel="..."
            nextLabel="Next >"
            onPageChange={(e) => setCurrentPage(e.selected)}
            pageRangeDisplayed={3}
            marginPagesDisplayed={1}
            pageCount={pagination.totalPages}
            previousLabel="< Prev"
            forcePage={currentPage}
            containerClassName="pagination"
            activeClassName="active"
          />
        </div>
      )}
    </div>
  );
};

export default WorkPackageTableData;
